import {useLocation} from 'react-router-dom';

const useUrlQuery = (query: string): string | null => {
	const location = useLocation();
	return new URLSearchParams(location.search).get(query.trim()) ?? null;
};

export default useUrlQuery